import react from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MatrixBrand from './MatrixBrand';
import { LuLogOut, LuClipboardCheck } from 'react-icons/lu';
import ReportBugButton from './ReportBugButton';

const MechanicsLayout = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };
    
    return (    
        <div className="flex flex-col h-screen bg-gray-50">
            <header className="bg-white shadow-md">
                <div className="container mx-auto px-6 py-3 flex justify-between items-center">
                    <div className="flex items-center space-x-8">
                        <MatrixBrand portal="Mechanics Portal" />
                        <nav>
                            <NavLink to="/mechanics/dashboard" className={({ isActive }) => `flex items-center text-sm font-medium ${isActive ? 'text-purple-600' : 'text-gray-600 hover:text-purple-600'}`}>
                                <LuClipboardCheck className="mr-1" />
                                My Tasks
                            </NavLink>
                        </nav>
                    </div>
                    <div className="flex items-center gap-4">
                        <ReportBugButton />
                        <button onClick={handleLogout} className="flex items-center text-sm text-gray-600 hover:text-red-600">
                            <LuLogOut className="mr-1" />
                            Logout
                        </button>
                    </div>
                </div>
            </header>
            <main className="flex-1 p-6 overflow-y-auto">
                <Outlet />
            </main>
        </div>
    );
};

export default MechanicsLayout;